<template>
  <section class="consult-rank-container">
    <img class="bg" :src="pageData.image | blur" />
    <div class="before"></div>
    <navbar
      ref="navbar"
      :title="title"
      :showTitle="showHeaderCenter"
      :fixed="true"
    >
      <div
        class="navbar-bg"
        :style="{
          opacity: showHeaderCenter ? 1 : 0,
          position: 'absolute'
        }"
        slot="fixed-slot"
      >
        <img
          :src="pageData.image | blur"
          class="bg"
          style="position: absolute"
        />
        <div class="before-mask" style="position: absolute" />
      </div>
    </navbar>
    <div class="consult-rank-content">
      <div class="fixed-top" ref="fixed-top">
        <div class="fixed-top-container">
          <h1 class="title">{{ title }}</h1>
          <h2 class="desc">
            <span class="count"
              >为你推荐{{ pageData.list.length }}位咨询师</span
            >
            <!-- <span class="update">每周更新</span> -->
          </h2>
        </div>
      </div>
      <div class="consult-rank-list" ref="consult-rank-list">
        <div class="consult-rank-list-container">
          <teacherItem
            v-for="(item, index) in pageData.list"
            :key="index"
            :item="item"
            :include="['recommend']"
          >
            <div
              class="recommend"
              slot="recommend"
              v-if="item.recommend && item.recommend.trim()"
            >
              <p class="text">
                {{ item.recommend.trim() }}
              </p>
            </div>
          </teacherItem>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import dataStore from 'store/consult/rank'
import teacherItem from 'app/web/component/consult/listCommon/item.vue'
import navbar from 'component/consult/navbar'
import { getScrollTop } from 'lib/tools/utils.js'
import consultPageMixin from 'app/web/mixins/consult/page.js'

export default {
  mixins: [consultPageMixin],
  dataStore,
  components: {
    teacherItem,
    navbar
  },
  data() {
    return {
      showTitle: false,
      disableScroll: false,
      moved: false,
      showHeaderCenter: false
    }
  },
  filters: {
    blur(img) {
      if (!img) return img
      return (
        img.split('?')[0] + `?x-oss-process=image/resize,w_200/blur,r_30,s_30`
      )
    }
  },
  preFetch({ store, route }) {
    const { id } = route.params
    return store.dispatch(`consultrank/fetchRank`, { id }).then(() => {
      store.commit('setMeta', {
        title: store.state.consultrank.rank.title,
        keywords:
          '心理咨询,在线心理咨询,心理咨询师,心理咨询医生,婚姻咨询,北京心理咨询,上海心理咨询,广州心理咨询',
        description:
          '壹心理咨询，致力于为全球用户提供可信赖的心理咨询服务。壹心理以2%甄选率的严苛标准筛选出海内外500多名优质咨询师，为14个国家地区的用户提供个人成长、婚姻情感及心理健康等方向的心理咨询服务。'
      })
    })
  },
  computed: {
    title() {
      /* 需求变更：直接白 */
      /* 广告位后端没有多余字段，所以用@分割title和statusbar颜色 */
      const { title } = this.pageData
      // if (title) {
      //   return title.split('@')[0]
      // }
      return title
    },
    showNavbar() {
      return this.$platform && this.$platform.isYixinliApp
    },
    pageData() {
      return this.$store.state.consultrank.rank
    },
    fixedTop() {
      if (this.$isServer) return
      return this.$refs['fixed-top']
    },
    shareConfig() {
      let _link = window.location.href.replace(
        document.location.origin,
        this.$mZXSafeOrigin
      )
      return {
        title: this.title,
        desc: `壹心理咨询，为你推荐专业、优质、可信赖的心理咨询师。`,
        link: _link,
        imgUrl: `https://ossimg.xinli001.com/20190724/cd2c3853c483ae18128e2358dbf423f2.jpeg`
      }
    },

    pageStatProperties() {
      const { id } = this.$route.params
      return {
        榜单ID: id
      }
    }
  },
  mounted() {
    this.$bridge.isPullRefreshEnable({
      enable: 0
    })

    this.$bridge.setStatusBarStyle({ style: 1 })

    window.addEventListener('scroll', this._scroll)

    this.setNativeShare()
  },
  methods: {
    _scroll() {
      const st = getScrollTop()
      this.showHeaderCenter = st > 100
    }
  }
}
</script>

<style lang="scss">
.consult-rank-container {
  position: absolute;
  top: 0;
  left: 50%;
  /*height: 100%;*/
  overflow: hidden;
  width: 750px;
  margin-left: -375px;
  background-size: cover;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 40%;
  }
  .before {
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: '';
  }
  .fixed-top {
    position: relative;
    height: 290px;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 60px;
    .title {
      font-size: 56px;
      color: #ffffff;
      line-height: 1;
      transform-origin: left 80%;
    }
    .desc {
      font-size: 30px;
      margin-top: 24px;
      /*padding-bottom: 60px;*/
      color: #ffffff;
      line-height: 1;
      display: flex;
      justify-content: space-between;
      span {
        font-weight: normal;
      }
    }
  }
  .consult-rank-content {
    height: 100%;
  }
  .consult-rank-list {
    position: relative;
    height: 100%;
    // transition: transform 0.3s;
    background: #ffffff;
    border-radius: 30px 30px 0 0;
    overflow-x: hidden;
    padding: 30px 0;
    .consult-teacher-item {
      padding-top: 40px;
      .consult-teacher-item-container {
        padding-bottom: 0px;
      }
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3) {
        .consult-teacher-item-avatar {
          position: relative;
        }
      }
    }
    .recommend {
      background: #ffffff;
      box-shadow: 0 8px 40px 0 #ececec;
      border-radius: 30px;
      margin: 20px 30px 0;
      padding: 20px 30px;
      .text {
        font-size: 26px;
        color: #6c798c;
        line-height: 42px;
        word-break: break-all;
        // @蔡佳铭：不要超出隐藏了
        // @include overLine(2);
      }
    }
  }
  .navbar-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    background: #ffa202;
    overflow: hidden;
    left: 0;
    top: 0;
    opacity: 0;
    transition: opacity 0.3s;
    .bg {
      width: 100%;
      height: 100%;
    }
  }
  .before-mask {
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: '';
  }
}
</style>
